import { Component, DestroyRef, ElementRef, effect, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivityStreamState } from '../../data/activity-stream.state';
import { LoadActivityStreamItems } from '../../data/activity-stream.actions';
import { ActivityStreamItem } from '@coin/shared/activity-stream/util';
import { GlobalEventsService, TinyHelpers } from '@coin/shared/core/util-helpers';
import { Store } from '@ngxs/store';

@Component({
  selector: 'coin-c-activity-stream-list',
  templateUrl: './activity-stream-list.component.html',
  styleUrls: ['./activity-stream-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActivityStreamListComponent {
  private events = inject(GlobalEventsService);
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  public items$ = this.store.select<ActivityStreamItem[]>(ActivityStreamState.items);
  public items: ActivityStreamItem[];

  public scrollContainer = viewChild<ElementRef<HTMLElement>>('scrollContainer');
  private lastScrollTop = 0;

  public constructor() {
    this.listenToItems();

    effect(() => {
      const container = this.scrollContainer();
      if (!container) {
        return;
      }

      container.nativeElement.onscroll = (event: WheelEvent) => {
        const target = event.target as HTMLElement;
        if (TinyHelpers.scrolledOverVerticalBound(event, this.lastScrollTop)) {
          this.lastScrollTop = target.scrollTop;
          this.store.dispatch(new LoadActivityStreamItems(false));
        }
      };
    });
  }

  public toggleItemDetails(clickedItem: ActivityStreamItem): void {
    this.items = this.items.map(item => ({
      ...item,
      isDetailVisible: item.id === clickedItem.id ? !item.isDetailVisible : false
    }));
  }

  private listenToItems(): void {
    this.items$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(items => {
      this.items = structuredClone(items);
    });
  }
  public clickout = (): void => {
    this.items = this.items.map(item => ({
      ...item,
      isDetailVisible: false
    }));
  };
}
